import { prefetchForProject } from "../../../lib/prefetch";

import { createFileRoute } from "@tanstack/react-router";

import { Worlds } from "./-worlds";
import { parseWorldView } from "../../../workspaces/worlds/search";

export const Route = createFileRoute(
  "/_console/p/$org/$project/simulate/assets/$worldId",
)({
  validateSearch: parseWorldView,
  loaderDeps: ({ search }) => ({ query: search.q }),
  loader: ({ context: { queryClient }, params, deps }) => prefetchForProject(
    queryClient, params, import("../../../workspaces/worlds/queries"),
    ({ prefetchWorldLists }, projectId) => prefetchWorldLists(queryClient, projectId, deps.query),
  ),
  component: SimulationAssetRoute,
});

/** One simulation asset — an environment, a scene or an object — open in the inspector. */
function SimulationAssetRoute() {
  const { worldId } = Route.useParams();
  return <Worlds state={{ ...Route.useSearch(), world: worldId }} />;
}
